import { render } from "./Ideas.vue?vue&type=template&id=2e64c038"
import script from "./Ideas.vue?vue&type=script&lang=ts"
export * from "./Ideas.vue?vue&type=script&lang=ts"
script.render = render

export default script